import { AnalyticsReportSettingsProps } from '~/data/reports';
import { CompensationEqualityCharts } from '~/scenes/PortalModules/Analytics/Rewarding/CompensationEqualityReport/CompensationEqualityCharts';
import { CompensationEqualityTable } from '~/scenes/PortalModules/Analytics/Rewarding/CompensationEqualityReport/CompensationEqualityTable';
import { CompensationEqualityReportEntry } from '~/scenes/PortalModules/Analytics/Rewarding/CompensationEqualityReport/data';

enum CompensationEqualityReportTab {
  Charts = 'charts',
  Table = 'table',
}

type PropsType = {
  reportTab: CompensationEqualityReportTab;
  rows: CompensationEqualityReportEntry[];
  reportSelection: AnalyticsReportSettingsProps<object>;
  currency: string;
  isLoading: boolean;
};

export const CompensationEqualityTabs = (props: PropsType) => {
  const { reportTab, rows, currency, reportSelection, isLoading } = props;

  switch (reportTab) {
    case CompensationEqualityReportTab.Charts:
      return (
        <CompensationEqualityCharts
          isLoading={isLoading}
          rows={rows}
          currency={currency}
        />
      );
    case CompensationEqualityReportTab.Table:
      return (
        <CompensationEqualityTable
          reportSelection={reportSelection}
          isLoading={isLoading}
          rows={rows}
          currency={currency}
        />
      );
  }
};
